import { Injectable } from '@angular/core'
import { PageModel, PagesumModel } from './page.model'
import { AjaxService } from 'src/app/shared/ajax.service'
import { CmodalModel } from '../components/cmodal/cmodal.model'
import { CmodalService } from '../components/cmodal/cmodal.service'
import { DomSanitizer } from '@angular/platform-browser'
import { GlobService } from 'src/app/shared/glob.service'
import { TreevModel, TreeviModel } from '../components/treev/treev.model';

@Injectable({
    providedIn: 'root'
})
export class PageService {
    model: PageModel
    layout: any[][]
    components: {
        chtms: any[],
        frms: any[],
        asks: any[],
        grds: any[],
        calens: any[],
        prm_grds_dep: any[],
        charts: any[],
        trvs: any[],
        progresses: any[],
        infocards: any[]
    }

    constructor(private glob: GlobService, private cmodalService: CmodalService, private sanitized: DomSanitizer, private ajax: AjaxService) {
        this.model = new PageModel()
    }

    get(callback, thos) { // : (arg0: { model: PageModel; modelsum: PagesumModel[][]; }) => void
        this.components = {
            chtms: [],
            frms: [],
            asks: [],
            grds: [],
            prm_grds_dep: [],
            charts: [],
            calens: [],
            trvs: [],
            progresses: [],
            infocards: []
        }

        let modelflat = []
        this.layout = []

        this.ajax.execute({
            url: 'page/get',
            data: { id: this.model.id },
            auth: true,
            success: (post: any) => {
                this.cmodalService.models = []

                // ----- page -----------------------------
                this.model.id = post.result.page.id
                this.model.menu_id = post.result.page.menu_id
                this.model.tit = post.result.page.tit
                this.model.nam = post.result.page.nam

                // ----- chtm -----------------------------
                for (let i = 0; i < post.result.chtm.length; i++) {
                    let chtm = post.result.chtm[i]
                    chtm.ssty = this.sanitized.bypassSecurityTrustStyle(chtm.sty)
                    chtm.ctyp = 'chtm'
                    modelflat.push(chtm)
                    if (chtm.dis == null) chtm.dis = 2
                    if (chtm.dis == 5) this.cmodalService.models.push(new CmodalModel('chtm', chtm.id, chtm.tit, chtm))
                    // setTimeout(() => {
                    //     this.cmodalService.implement(chtm.id, null)
                    //     let cm: any = $('#cmodal')
                    //     cm.modal('show')
                    // }, 3000);
                }
                this.model.chtms = post.result.chtm

                // ----- grid -----------------------------
                for (let i = 0; i < post.result.grid.length; i++) {
                    let grd = post.result.grid[i]
                    grd.ssty = this.sanitized.bypassSecurityTrustStyle(grd.sty)
                    grd.sstyp = this.sanitized.bypassSecurityTrustStyle(grd.styp)
                    grd.ctyp = 'grid'
                    modelflat.push(grd)
                    if (grd.sela) grd.dats_sel = []
                    // grd.cols = []
                    let imediate_opts = []
                    for (let col of grd.cols) {
                        // if (!col.flt) col.flt = { vis: 1, mod: 1 }
                        if (col.flt.vis == undefined || col.flt.vis == null) col.flt.vis = true
                        if (!col.flt.mod) col.flt.mod = 1

                        if (col.cmp == 2) {
                            if (!col.cnf) col.cnf = { "typ": 1 }
                        }
                        if (col.cmp == 6) {
                            if (!col.cnf.mod) col.cnf.mod = 1
                            if (!col.cnf.config) col.cnf.config = { "format": "jYYYY-jMM-jDD", "format_out": "jYYYYjMMjDD" }

                            switch (col.cnf.mod) {
                                case 1:
                                    if (!col.cnf.config.format) col.cnf.config.format = 'jYYYY-jMM-jDD'
                                    if (!col.cnf.config.format_out) col.cnf.config.format_out = 'jYYYYjMMjDD'
                                    if (!col.cnf.plh) col.cnf.plh = 'yyyy-mm-dd'
                                    break
                                case 2:
                                    if (!col.cnf.config.format) col.cnf.config.format = 'HH:mm'
                                    if (!col.cnf.config.format_out) col.cnf.config.format_out = 'sumsec'
                                    if (col.cnf.config.openOnFocus !== false && col.cnf.config.openOnFucus !== true) col.cnf.config.openOnFocus = false
                                    if (col.cnf.config.openOnClick !== false && col.cnf.config.openOnClick !== true) col.cnf.config.openOnClick = false
                                    if (!col.cnf.plh) col.cnf.plh = 'hh:mm'
                                    break
                            }
                            if (col.flt.mod == 3) col.flt.val = col.flt.val ? col.flt.val.split('◙') : ['', '']
                        }
                        if (col.cmp == 8 || col.cmp == 10 || col.cmp == 13) {
                            col.pip = `this.slice(val, '◙', 1)`
                            if (!col.flt.lod) col.flt.lod = 0
                            if (!col.fk.lod) col.fk.lod = 0

                            if (col.flt.lod == 0 && col.flt.vis != false && grd.flt != false) { imediate_opts.push(col.cmp == 8 ? col.val.split(' ')[0] : col.vals); }
                            else if (col.flt.lod > 0 && col.flt.vis != false && grd.flt != false)
                                setTimeout(() => {
                                    this.ajax.execute({
                                        url: 'grid/opts',
                                        data: { grid_id: grd.id, alsz: col.cmp == 8 ? col.val.split(' ')[0] : col.vals, witch: 'flt' },
                                        success: (post) => {
                                            col.flt.opts = post.result.opts
                                            if (col.fk.slt == col.flt.slt && col.fk.whe == col.flt.whe) col.fk.opts = post.result.opts
                                        }
                                    })
                                }, col.flt.lod * 1000);
                        }

                        if (col.cmp == 9) col.pip = `this.qlist(val, model.cols[ci].cnf)`
                        col.ssty = this.sanitized.bypassSecurityTrustStyle(col.sty)
                        col.sstyp = this.sanitized.bypassSecurityTrustStyle(col.styp)

                        if (col.data_type_id == 114)
                            col.pip = 'this.json(val)'
                    }
                    if (imediate_opts.length != 0) {
                        this.ajax.execute({
                            url: 'grid/opts',
                            data: { grid_id: grd.id, alsz: imediate_opts.join(','), witch: 'flt' },
                            success: (post) => {
                                for (let o of post.result) {
                                    let col = grd.cols.find(x => (x.cmp == 8 ? x.val.split(' ')[0] : x.vals) == o.als)
                                    if (col) col.flt.opts = o.lst
                                }
                            }
                        })
                    }

                    grd.dras = grd.evts.filter(x => x.key == "data_row_action")

                    if (grd.pars) {
                        grd.pars = grd.pars.split(';')
                        for (let i: number = 0; i < grd.pars.length; i++)
                            grd.pars[i] = grd.pars[i].split(',')
                    }

                    grd.cols_vis = grd.cols.filter((x: { dis: number; }) => x.dis != 3)
                    if (grd.dis == null) grd.dis = 21
                    grd.disf = grd.dis - Math.floor(grd.dis / 10) * 10
                    grd.dis = Math.floor(grd.dis / 10)
                    if (grd.dis == 5 || grd.disf) this.cmodalService.models.push(new CmodalModel('grid', grd.id, grd.tit, grd))
                    grd.sta = 1
                }
                this.model.grds = post.result.grid

                // ----- formy ----------------------------
                // for (let i = 0; i < post.result.grid.length; i++) {
                //     let grd = post.result.grid[i]
                //     if (!grd.frm || !grd.frm.dis) continue

                //     // if (frm.dis == 4) this.cmodalService.models.push(new CmodalModel('formy', frm.id, frm.tit, frm))
                //     // frm.flds.sort((a: { srt: number; }, b: { srt: number; }) => { return a.srt < b.srt ? -1 : 1 })
                // }
                // this.model.frms = post.result.formy

                // ----- permit -----------------------
                // if (post.result.permit)
                //     for (let i = 0; i < this.model.grds.length; i++) {
                //         let prm = post.result.permit.filter(x => x.grid.grid_id == this.model.grds[i].id)
                //         this.model.grds[i].prm = prm && prm.length > 0 ? prm[0] : null
                //     }

                // ----- chart ----------------------------
                for (let i = 0; i < post.result.chart.length; i++) {
                    let chart = post.result.chart[i]
                    chart.ssty = this.sanitized.bypassSecurityTrustStyle(chart.sty)
                    chart.sstyp = this.sanitized.bypassSecurityTrustStyle(chart.styp)
                    chart.ctyp = 'chart'
                    if (chart.dis == null) chart.dis = 2
                    modelflat.push(chart)
                    if (chart.dis == 5) this.cmodalService.models.push(new CmodalModel('chart', chart.id, chart.tit, chart))
                }
                this.model.charts = post.result.chart

                // ----- treev ----------------------------
                for (let ti of post.result.treevi) {
                    if (ti.cnf == null) ti.cnf = {}
                    if (ti.cnf.exp == null) ti.cnf.exp = 0
                }
                let trvs: TreevModel[] = []
                for (let i = 0; i < post.result.treev.length; i++) {
                    let treev = post.result.treev[i]
                    let o = post.result.treevi.filter(x => x.treev_id == treev.id)
                    treev.trvis = this.list_to_tree(post.result.treevi)
                    treev.ssty = this.sanitized.bypassSecurityTrustStyle(treev.sty)
                    treev.sstyp = this.sanitized.bypassSecurityTrustStyle(treev.styp)
                    treev.ctyp = 'treev'
                    if (treev.dis == null) treev.dis = 2
                    modelflat.push(treev)
                    if (treev.dis == 5) this.cmodalService.models.push(new CmodalModel('treev', treev.id, treev.tit, treev))
                }
                this.model.trvs = post.result.treev

                // ----- infocard -------------------------
                for (let i = 0; i < post.result.infocard.length; i++) {
                    let ic = post.result.infocard[i]
                    ic.ssty = this.sanitized.bypassSecurityTrustStyle(ic.sty)
                    ic.ctyp = 'infocard'
                    if (ic.cnf == null) ic.cnf = {}
                    modelflat.push(ic)
                    if (ic.dis == null) ic.dis = 2
                    if (ic.dis == 5) this.cmodalService.models.push(new CmodalModel('infocard', ic.id, ic.tit, ic))
                }
                this.model.infocards = post.result.infocard


                // ----- layout ---------------------------------
                modelflat.sort((a, b) => { return a.srt < b.srt ? -1 : 1 })
                let distinct = []
                if (modelflat.length > 0) modelflat[0].row = true
                for (let i = 0; i < modelflat.length; i++) {
                    let m = modelflat[i]
                    if (m.ctyp == 'grid') {
                        if ([1, 5].find(x => x == m.dis) && [1, 5].find(x => x == m.disf)) { modelflat.splice(i, 1); i--; continue }
                    }
                    else {
                        if (m.dis == 1 || m.dis == 5) { modelflat.splice(i, 1); i--; continue }
                    }

                    if (m.grp == null) m.grp = (i + 1) * 313
                    if (!distinct.find(x => x == m.grp)) distinct.push(m.grp)
                }

                for (let i = 0; i < distinct.length; i++) {
                    let col = modelflat.filter(x => x.grp == distinct[i])
                    let distin = []
                    for (let u = 0; u < col.length; u++) {
                        if (col[u].dis == 2) col[u].temp = (u + 313)
                        else col[u].temp = col[u].dis

                        if (!distin.find(x => x == col[u].temp)) distin.push(col[u].temp)
                    }

                    let coldis = []
                    for (let u = 0; u < distin.length; u++) {
                        coldis.push(col.filter(x => x.temp == distin[u]))
                    }
                    this.layout.push(coldis)
                }
                console.log('page model post', post.result)
                console.log('page model', this.model)
                console.log('page layout', this.layout)

                callback(this.model, this.layout)
                document.title = this.glob.config && this.glob.config.tit ? this.glob.config.tit : '.'
            }
        })
    }

    list_to_tree(list) {
        var map = {}, node, roots = [], i;
        for (i = 0; i < list.length; i += 1) {
            map[list[i].id] = i; // initialize the map
            list[i].trvis = []; // initialize the children
        }
        for (i = 0; i < list.length; i += 1) {
            node = list[i];
            if (node.parent_id !== null) {
                // if you have dangling branches check that map[node.parentId] exists
                list[map[node.parent_id]].trvis.push(node);
            } else {
                roots.push(node);
            }
        }
        return roots;
    }
}
